import React from 'react';
import { Instagram, Facebook, Youtube, Link, Mail, Music } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#1f2933] text-white py-12 border-t border-gray-700" data-id="element-46">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-48">
          {/* Brand */}
          <div data-id="element-49">
            <h3 className="text-xl font-bold mb-4" data-id="element-50">Netanel Tours VIP</h3>
            <p className="text-gray-400 text-sm max-w-xs" data-id="element-51">
              Your personal global luxury travel concierge. Customized trips,
              exclusive deals, and VIP support worldwide.
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-52">
            <h4 className="text-lg font-semibold mb-4" data-id="element-53">Contact Us</h4>
            <div className="space-y-3" data-id="element-54">
              <a href="mailto:NetanelToursVip@gmail.com" className="flex items-center text-gray-400 hover:text-white transition-colors" data-id="element-55">
                <Mail className="h-5 w-5 mr-2" data-id="element-56" />
                <span data-id="element-57">NetanelToursVip@gmail.com</span>
              </a>
              <div className="flex items-center text-gray-400" data-id="element-58">
                <span className="text-sm" data-id="element-59">Available 24/7 for VIP clients</span>
              </div>
            </div>
          </div>

          {/* Social Links */}
          <div data-id="element-60">
            <h4 className="text-lg font-semibold mb-4" data-id="element-61">Follow Us</h4>
            <div className="flex space-x-4" data-id="element-62">
              <a href="https://www.instagram.com/netaneltoursvip/" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors" aria-label="Instagram" data-id="element-63">
                <Instagram className="h-5 w-5" data-id="element-64" />
              </a>
              <a href="https://www.tiktok.com/@netaneltoursvip" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors" aria-label="TikTok" data-id="element-65">
                <Music className="h-5 w-5" data-id="element-66" />
              </a>
              <a href="https://www.facebook.com/Netaneltoursvip/" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors" aria-label="Facebook" data-id="element-67">
                <Facebook className="h-5 w-5" data-id="element-68" />
              </a>
              <a href="https://www.youtube.com/channel/UCn3ITLWTCijIQtKYmavQqbQ" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors" aria-label="YouTube" data-id="element-69">
                <Youtube className="h-5 w-5" data-id="element-70" />
              </a>
              <a href="https://linktr.ee/netaneltoursvip" target="_blank" rel="noopener noreferrer" className="bg-gray-800 p-2 rounded-full hover:bg-gray-700 transition-colors" aria-label="Linktree" data-id="element-71">
                <Link className="h-5 w-5" data-id="element-72" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8 text-center text-sm text-gray-500" data-id="element-73">
          <p data-id="element-74">&copy; 2026 Netanel Tours VIP. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}